import React from 'react';

const EmojiCrushPrivacyPolicy = () => {
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
            <h1>Privacy Policy for Emoji Crush | Smash</h1>
            <p>Last updated: 30/08/2024</p>

            <p>
                Thank you for using Emoji Crush | Smash. We respect your privacy and are committed to protecting
                it. This Privacy Policy outlines our practices regarding any data that may be collected when you use our
                mobile application ("App").
            </p>

            <h2>No Data Collection</h2>
            <p>
                We do not collect, store, or share any personal data or information from our users. Emoji Crush | Smash is designed to be a simple and enjoyable experience without requiring any personal information or data
                from you.
            </p>

            <h2>Changes to This Privacy Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page. We encourage
                you to review this page periodically for any updates.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:leblebiapps1@gmail.com">leblebiapps1@gmail.com</a> .
            </p>
        </div>
    );
};

export default EmojiCrushPrivacyPolicy;